export const clientTypeId = "42302cdd-4951-4488-b7c3-f82638d39d3c";
export const clientTypeSecret = "WebWorkspace";

export const googleClientId = "353797435803-p3db21nocv0ad1j5ph2i7c5qbvcvd6vq.apps.googleusercontent.com";
export const googleProviderId = "628ea29d-e275-40fa-a3e9-932d7e5f36bb";

export const microsoftClientId = "07d959be-ab6c-42bb-935d-4fda0b176afc";
export const microsoftProviderId = "17107a3a-09a5-4817-b324-2039dc476571";